export default __webpack_public_path__ + "static/15_29-f1207dd48d51170c434475b9a493954d.png";